import React from 'react';
import { createUseStyles, clsx, subtract } from '@pushpay/styles';
import { useResponsiveProp } from '@pushpay/theming';
import { alignHMap } from './alignment';
import { Box } from './box';
import { getLayoutSpaceOrPx } from './helpers';
const useStyles = createUseStyles(theme => ({
  root: ({
    alignH,
    space
  }) => ({
    display: 'flex',
    justifyContent: alignHMap[alignH],
    paddingTop: getLayoutSpaceOrPx(theme, space)
  }),
  stretch: {
    flexGrow: 1
  },
  stickyTop: ({
    stickyTop,
    space
  }) => ({
    position: 'sticky',
    top: subtract(getLayoutSpaceOrPx(theme, typeof stickyTop === 'boolean' ? 0 : stickyTop), getLayoutSpaceOrPx(theme, space))
  }),
  stickyBottom: ({
    stickyBottom
  }) => ({
    position: 'sticky',
    bottom: getLayoutSpaceOrPx(theme, typeof stickyBottom === 'boolean' ? 0 : stickyBottom)
  })
}));

/**
 * Use this StackItem component within a Stack when you want to break out of the parents default stacking rules
 */
export const StackItem = ({
  component,
  space: spaceProp,
  spacePx,
  alignH: alignHProp,
  stickyTop: stickyTopProp = false,
  stickyBottom: stickyBottomProp = false,
  stretch,
  classes: classesProp,
  className: classNameProp,
  children,
  ...rest
}) => {
  const space = useResponsiveProp(spacePx !== null && spacePx !== void 0 ? spacePx : spaceProp);
  const alignH = useResponsiveProp(alignHProp);
  const stickyTop = useResponsiveProp(stickyTopProp);
  const stickyBottom = useResponsiveProp(stickyBottomProp);
  const classes = useStyles(classesProp, {
    space,
    alignH,
    stickyTop,
    stickyBottom
  });
  const className = clsx(classNameProp, classes.root, stretch && classes.stretch, stickyTop !== false && classes.stickyTop, stickyBottom !== false && classes.stickyBottom);
  return /*#__PURE__*/React.createElement(Box, Object.assign({
    className: className,
    component: component
  }, rest), children);
};